import { ChevronDown } from "lucide-react";
import React from "react";

import { IgBorderColors, IgDivider } from "@intelligems/ig-theme";
import {
  AgencySubscriptionDto,
  AgencySubscriptionItemDto,
  FullAgencyDto,
} from "@intelligems/ig-types";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  useTheme,
} from "@mui/material";
import { MeterLabel } from "@src/features/admin/pages/agencies/components/Expansions/AgenciesPanel/SubscriptionsTab/AgencySubscriptionPanel/AgencyProductAccordion/MeterLabel";
import { Summary } from "@src/features/admin/pages/agencies/components/Expansions/AgenciesPanel/SubscriptionsTab/AgencySubscriptionPanel/AgencyProductAccordion/Summary";
import { TableSection } from "@src/features/admin/pages/agencies/components/Expansions/AgenciesPanel/SubscriptionsTab/AgencySubscriptionPanel/AgencyProductAccordion/TableSection";

interface AgencyProductAccordionProps {
  item: AgencySubscriptionItemDto;
  subscription: AgencySubscriptionDto;
  agency: FullAgencyDto;
}
export const AgencyProductAccordion = ({
  item,
  subscription,
  agency,
}: AgencyProductAccordionProps) => {
  const theme = useTheme();
  return (
    <Accordion
      disableGutters
      defaultExpanded={true}
      elevation={0}
      square
      sx={{ border: `1px solid ${IgBorderColors.core.default}` }}
    >
      <AccordionSummary
        sx={{
          marginLeft: "10px",
          marginRight: "10px",
          flexDirection: "row-reverse",
          paddingLeft: 0,
          paddingRight: 0,
        }}
        expandIcon={<ChevronDown size={16} />}
      >
        <Summary item={item} />
      </AccordionSummary>
      <IgDivider />
      <AccordionDetails
        sx={{ marginLeft: "16px", marginRight: "16px", marginTop: "4px" }}
      >
        <Grid container item direction={"column"} rowSpacing={2}>
          <MeterLabel item={item} />
          <TableSection
            item={item}
            agency={agency}
            subscription={subscription}
          />
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};
